<template>
  <router-view v-slot="{ Component }">
    <transition name="fade">
      <div>
        <component :is="Component" />
        <!-- <Toast ref="toastalert" /> -->
      </div>
    </transition>
  </router-view>
</template>

<script>
// import Toast from '@src/components/Toast.vue';
export default {
  name: "App",
  components: {
    // Toast,
  },
  computed: {
    // getToasts() {
    //   return this.$store.state.toast.toasts;
    // }
  },
  watch: {
    // getToasts(val) {
    //   if (val) {
    //     this.$refs.toastalert.toastTrigger(val.message, val.type);
    //   }
    // },
  },
  created() {
  },
  methods: {
  },
};
</script>